import React from "react";
import Card from "../../component/Card";
import signUpImage from "../../assets/signUpImg.png";
import { useSignUp } from "./useSignUp";

const SignUpPage = () => {
  const { state, handleChange, signInHandler } = useSignUp();
  return (
    <div className="flex items-center justify-center h-screen">
      <Card>
        <div className="flex flex-col gap-5 p-10">
          <div className="flex items-center gap-3 justify-between">
            <div className="flex flex-col gap-3">
              <span className="text-2xl font-semibold">Create account</span>
              <span className="text-gray-500">Let us know about your self</span>
            </div>
            <img src={signUpImage} alt="sign-up" className="h-28" />
          </div>
          <div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="name"
              >
                Name
              </label>
              <input
                id="name"
                type="text"
                value={state.name}
                onChange={(e) => handleChange(e, "name")}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your name"
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                type="email"
                value={state.email}
                onChange={(e) => handleChange(e, "email")}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter email address"
              />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="phone"
              >
                Mobile Number
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/in.svg"
                    alt="IN"
                    className="w-4 h-3 mr-2"
                  />
                  +91
                </span>
                <input
                  id="phone"
                  type="tel"
                  value={state.phone}
                  onChange={(e) => handleChange(e, "phone")}
                  className="shadow appearance-none border rounded w-full py-2 px-3 pl-16 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Enter mobile number"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 items-center justify-center w-full">
              <button className="bg-emerald-500 mb-3 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                Signup
              </button>
              <span className="text-gray-500">Already Have An Account?</span>
              <button
                onClick={signInHandler}
                className="inline-block align-baseline font-bold text-sm text-emerald-500 hover:text-emerald-600"
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SignUpPage;
